<script lang="ts">
    import type {Minithumbnail} from "./Types";
    export let entity: Minithumbnail
</script>
{#if entity}
<img alt="" width={entity.width} height={entity.height} src="data:image/png;base64,{entity.data}">
{/if}
